export type AcceptedCurrencyCode = 'DKK' | 'EUR'

type CurrencySymbol = { prefix?: string; suffix?: string }

export const isAcceptedCurrencyCode = (code: string): code is keyof typeof currencyCodeToSymbol =>
  code in currencyCodeToSymbol

export const currencyCodeToSymbol: Record<AcceptedCurrencyCode, CurrencySymbol> = {
  DKK: { suffix: 'DKK' },
  EUR: { prefix: '€' },
}
